// again-pdp-hike.js — hike-style PDP sections.
// <ag-inview-video>: same contract as ag-why-loop — the <video> ships with preload="none" and no src
// (data-src). First time it is on screen: set src + play; off screen: pause. Reduced motion or no
// IntersectionObserver: never loads, the poster stays. data-src-mobile (4:5 cut) wins under 750 px.
// <ag-reviews>: "Show more reviews" reveals the hidden cards.
class AgInviewVideo extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video || this._io || !('IntersectionObserver' in window)) return;
    video.muted = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    this._io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !reduce.matches) {
            if (!video.src && video.dataset.src) {
              const phone = video.dataset.srcMobile && window.matchMedia('(max-width: 749px)').matches;
              video.src = phone ? video.dataset.srcMobile : video.dataset.src;
              video.preload = 'auto';
            }
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else if (video.src) {
            video.pause();
          }
        });
      },
      { threshold: 0.2 }
    );
    this._io.observe(this);
  }
  disconnectedCallback() {
    this._io?.disconnect();
    this._io = null;
  }
}
if (!customElements.get('ag-inview-video')) customElements.define('ag-inview-video', AgInviewVideo);

class AgReviews extends HTMLElement {
  connectedCallback() {
    const btn = this.parentElement?.querySelector('[data-reviews-more]');
    if (!btn || this._bound) return;
    this._bound = true;
    const step = parseInt(this.dataset.show, 10) || 8;
    btn.addEventListener('click', () => {
      const rest = [...this.querySelectorAll('[data-more][hidden]')];
      rest.slice(0, step).forEach((el) => el.removeAttribute('hidden'));
      if (rest.length <= step) btn.parentElement.remove();
    });
  }
}
if (!customElements.get('ag-reviews')) customElements.define('ag-reviews', AgReviews);

// Photo strip: a tap on a customer photo reveals that review even when it sits behind "Show more".
document.addEventListener('click', (e) => {
  const a = e.target.closest?.('[data-rev-jump]');
  if (!a) return;
  const card = document.querySelector(a.getAttribute('href'));
  if (!card) return;
  e.preventDefault();
  card.removeAttribute('hidden');
  card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  history.replaceState(null, '', a.getAttribute('href'));
});
